com.TI.diagramManager.config = function (str) {
	var private_variables = {
		rd_prod_assets: {
			// HTML layouts
			layout: {
				diagram_list: "<div data-diagram-sub-system='' class='diagram-list c8'></div>",

				ee_list_row: "" +
					"<li>" +
					"    <a href='javascript://' class='{{default_class}}' data-subsystem-list-default='{{is_default}}' data-reference-link='{{subsysurl}}' name='{{subsystem_linkid_list}}' data-subsystem='{{subsysid}}'>" +
					"        {{subsystem_label}}" +
					"    </a>" +
					"</li>",

				base: "<div data-diagram-type='product-details' class='product-details-box'></div>",

				// Version A1 related HTML assets
				A1: {
					diagram_container: "" +
						"<div data-diagram-id='{{end_equipment_id}}' class='diagram-box c6'>" +
						"    <div class='legend-box'>" +
						"        <h4>{{diagram_container_title}}</h4>" +
						"        {{diagram_variant_select}}" +
						"    </div>" +
						"    <div data-diagram-target class='diagram-display-box'></div>" +
						"</div>" +
						"<div data-diagram-sub-system='' class='diagram-list c6'></div>",

					box_body: "" +
						"<div class='assoc-list-container'>" +
						"    <div class='assoc-list-headline'>" +
						"        <div class='headline-header'>" +
						"            <h4>{{subsystem_title}}</h4> <span class='description-link'><a" +
					" href='#' name='{{lid_description_link}}'>{{read_description}}<i" +
					" class='material-icons'></i></a></span>" +
						"            <ul class='assoc-list-tabs'>" +
						"                <li data-prod-details-tab='ti-products'>" +
						"                    <span class='tab-title-box'>{{ti_prod_title}}</span>" +
						"                    <span class='ti-product-count'>(<span>0</span>)</span>" +
						"                </li>" +
						"                <li data-prod-details-tab='ref-designs'>" +
						"                    <span class='tab-title-box'>{{ref_design_title}}</span>" +
						"                    <span class='ref-design-count'>(<span>0</span>)</span>" +
						"                </li>" +
						"            </ul>" +
						"            <div id='sticky'></div>" +
						"        </div>" +
						"        <div class='ref-designs-products-container'>" +
						"           <div class='ti-products active'>" +
						"               <div id='group-header-index'></div>" +
						"           </div>" +
						"           <div class='ref-designs active'></div>" +
						"        </div>" +
						"    </div>" +
						"</div>",

					ref_design_row: "<div class='cell-row clear'>{{cell_row_primary_level}}{{cell_row_secondary_level}}</div>",

					product_row: "<div class='cell-row clear expandproduct'>{{cell_row_primary_level}}{{cell_row_secondary_level}}</div>",

					ref_design_cell_row: {
						cell_row_primary_level: "" +
							"<div class='lvl primary clear'>" +
							"   <a href='{{row_url}}' target='_blank' name='{{ref_designs_linkid_text}}'></a> <span class='top-desc'>" +
							"       {{ref_new_label}}{{row_name}} " +
							"    </span>" +
							"    {{view_more_container}}" +
							"</div>",

						cell_row_secondary_level: "" +
							"<div class='lvl secondary clear'>" +
							"    <div class='c10'>" +
							"        <div class='row'>" +
							"            <ul class='ticom-ui-icons-list'>" +
							"                <li class='ticom-icon-item'>" +
							"                   <div class=\"ti_icon mod-size-s mod-color2\">" +
							"                       <svg role=\"img\">" +
							"                           <use xlink:href=\"/etc/designs/ti/images/icons/svg/ti_icons-objects.svg#document-web\"></use>" +
							"                       </svg>" +
							"                   </div>" +
							"                   <a href='{{diagram}}' class='ticom-icon-label' target='_blank' name='{{ref_designs_linkid_schematic}}'>{{cta_text1}}</a>" +
							"                </li>" +
							"                <li class='ticom-icon-item'>" +
							"                   <div class=\"ti_icon mod-size-s mod-color2\">" +
							"                       <svg role=\"img\">" +
							"                           <use xlink:href=\"/etc/designs/ti/images/icons/svg/ti_icons-objects.svg#document-generic\"></use>" +
							"                       </svg>" +
							"                   </div>" +
							"                   <a href='{{reference_guide}}' class='ticom-icon-label' target='_blank' name='{{ref_designs_linkid_referenceguide}}'>{{cta_text2}}</a>" +
							"                </li>" +
							"                <li class='ticom-icon-item'>" +
							"                   <div class=\"ti_icon mod-size-s mod-color2\">" +
							"                       <svg role=\"img\">" +
							"                           <use xlink:href=\"/etc/designs/ti/images/icons/svg/ti_icons-objects.svg#onlineDataSheet\"></use>" +
							"                       </svg>" +
							"                   </div>" +
							"                   <a href='{{row_url3}}' class='ticom-icon-label' target='_blank' name='{{ref_designs_linkid_viewfolder}}'>{{cta_text3}}</a>" +
							"                </li>" +
							"            </ul>" +
							"        </div>" +
							"    </div>" +
							"</div>"
					},

					product_cell_row: {
						cell_row_primary_level: "" +
							"<div class='lvl primary clear expandproduct'>" +
						    "    <a href='{{row_url}}' class='link-primary' target='_blank' name='{{products_linkid_text}}'>{{row_gpn}}</a>" +
						    "    &nbsp;" +
						    "  <span class='top-desc expandproduct'>{{new_label}}</span>" +
							"    <div class='col-md-8'>" +
							"      {{row_desc}}" +
							"      {{view_more_container}}" +
							"    </div>"+
							"</div>",
						cell_row_secondary_level: "" +
							"<div class='lvl secondary clear'>" +
						"   <div class='c9'>" +
							"        <div class='row'>" +
							"            <ul class='ticom-ui-icons-list'>" +
							"                <li class='ticom-icon-item'>" +
							"                   <div class=\"ti_icon mod-size-s mod-color3\">\n" +
							"                         <svg role=\"img\">\n" +
							"                             <use xlink:href=\"/etc/designs/ti/images/icons/svg/ti_icons-objects.svg#shoppingCart\"></use>\n" +
							"                         </svg>\n" +
							"                     </div>\n" +
							"                   <a href='{{order}}' class='ticom-icon-label order-now' target='_blank'" +
							" name='{{products_linkid_ordernow}}'>{{cta_text1}}</a>" +
							"                </li>" +
							"                <li class='ticom-icon-item'>" +
							"                   <div class=\"ti_icon mod-size-s mod-color2\">" +
							"                       <svg role=\"img\">" +
							"                           <use xlink:href=\"/etc/designs/ti/images/icons/svg/ti_icons-objects.svg#onlineDataSheet\"></use>" +
							"                       </svg>" +
							"                   </div>" +
							"                   <a href='{{online_datasheet}}' class='ticom-icon-label' target='_blank' name='{{products_linkid_onlinedatasheet}}'>{{cta_text2}}</a>" +
							"                </li>" +
							"                <li class='ticom-icon-item'>" +
							"                   <div class=\"ti_icon mod-size-s mod-color2\">" +
							"                       <svg role=\"img\">" +
							"                           <use xlink:href=\"/etc/designs/ti/images/icons/svg/ti_icons-objects.svg#document-pdfAcrobat\"></use>" +
							"                       </svg>" +
							"                   </div>" +
							"                   <a href='{{download_datasheet}}' class='ticom-icon-label' target='_blank' name='{{products_linkid_downloaddatasheet}}'>{{cta_text3}}</a>" +
							"                </li>" +
							"            </ul>" +
							"        </div>" +
							"    </div>" +
							"</div>"
					},

					headline_desc: "" +
						"<div class='subsystem-description'>" +
						"    <p>{{subsystem_desc}}</p>" +
						"</div>",

					image_box: {
						src: "<img src='{{row_image}}'/>",
						fallback: "<span>&nbsp;</span>"
					}
				},

				// Version A2 related HTML assets
				A2: {
					diagram_container: "" +
						"<div class='legend-box'>" +
						"    <h4>{{diagram_container_title}}</h4>" +
						"    {{diagram_variant_select}}" +
						"</div>" +
						"<div data-display-component class='component-display'>" +
						"    <div data-diagram-id='{{end_equipment_id}}' class='diagram-box c3'>" +
						"        <ul></ul>" +
						"    </div>" +
						"    <div data-diagram-sub-system='' class='diagram-list c9'>" +
						"</div>",

					box_body: "" +
						"<div class='assoc-list-container'>" +
						"    <div class='assoc-list-headline'>" +
						"        <div class='headline-header'>" +
						"            <h4>{{subsystem_title}}</h4> <span class='description-link'><a" +
					" href='#' name='{{lid_description_link}}'>{{read_description}}<i" +
					" class='material-icons'></i></a></span>" +
						"            <ul class='assoc-list-tabs'>" +
						"                <li data-prod-details-tab='ti-products'>" +
						"                    <span class='tab-title-box'>{{ti_prod_title}}</span>" +
						"                    <span class='ti-product-count'>(<span>0</span>)</span>" +
						"                </li>" +
						"                <li data-prod-details-tab='ref-designs'>" +
						"                    <span class='tab-title-box'>{{ref_design_title}}</span>" +
						"                    <span class='ref-design-count'>(<span>0</span>)</span>" +
						"                </li>" +
						"            </ul>" +
						"            <div id='sticky'></div>" +
						"        </div>" +
						"        <div class='ref-designs-products-container'>" +
						"           <div class='ti-products active'>" +
						"               <div id='group-header-index'></div>" +
						"           </div>" +
						"           <div class='ref-designs active'></div>" +
						"        </div>" +
						"    </div>" +
						"</div>",

					ref_design_row: "<div class='cell-row clear'>{{cell_row_primary_level}}{{cell_row_secondary_level}}</div>",

					product_row: "<div class='cell-row clear expandproduct'>{{cell_row_primary_level}}{{cell_row_secondary_level}}</div>",

					ref_design_cell_row: {
						cell_row_primary_level: "" +
							"<div class='lvl primary clear'>" +
							"    <span class='top-desc'>" +
							"        <a href='{{row_url}}' target='_blank' name='{{ref_designs_linkid_text}}'>{{row_name}}{{new_label}}</a>" +
							"    </span>" +
							"    {{view_more_container}}" +
							"</div>",

						cell_row_secondary_level: "" +
							"<div class='lvl secondary clear'>" +
							"    <div class='c10'>" +
							"        <div class='row'>" +
							"            <ul class='c4 ticom-ui-icons-list'>" +
							"                <li class='ticom-icon-item'>" +
							"                   <div class=\"ti_icon mod-size-s mod-color2\">" +
							"                       <svg role=\"img\">" +
							"                           <use xlink:href=\"/etc/designs/ti/images/icons/svg/ti_icons-objects.svg#document-web\"></use>" +
							"                       </svg>" +
							"                   </div>" +
							"                   <a href='{{diagram}}' class='ticom-icon-label' target='_blank' name='{{ref_designs_linkid_schematic}}'>{{cta_text1}}</a>" +
							"                </li>" +
							"                <li class='ticom-icon-item'>" +
							"                   <div class=\"ti_icon mod-size-s mod-color2\">" +
							"                       <svg role=\"img\">" +
							"                           <use xlink:href=\"/etc/designs/ti/images/icons/svg/ti_icons-objects.svg#document-generic\"></use>" +
							"                       </svg>" +
							"                   </div>" +
							"                   <a href='{{reference_guide}}' class='ticom-icon-label' target='_blank' name='{{ref_designs_linkid_referenceguide}}'>{{cta_text2}}</a>" +
							"                </li>" +
							"                <li class='ticom-icon-item'>" +
							"                   <div class=\"ti_icon mod-size-s mod-color2\">" +
							"                       <svg role=\"img\">" +
							"                           <use xlink:href=\"/etc/designs/ti/images/icons/svg/ti_icons-objects.svg#onlineDataSheet\"></use>" +
							"                       </svg>" +
							"                   </div>" +
							"                   <a href='{{row_url3}}' class='ticom-icon-label' target='_blank' name='{{ref_designs_linkid_viewfolder}}'>{{cta_text3}}</a>" +
							"                </li>" +
							"            </ul>" +
							"            <div class='c8'>{{row_desc1}}</div>" +
							"        </div>" +
							"    </div>" +
							"</div>"
					},

					product_cell_row: {
						cell_row_primary_level: "" +
							"<div class='lvl primary clear expandproduct'>" +
							"    <a href='{{row_url}}' class='link-primary' target='_blank' name='{{products_linkid_text}}'>{{row_gpn}}</a>" +
							"    &nbsp;&ndash;&nbsp;" +
							"    <span class='top-desc expandproduct'>{{row_desc}}{{new_label}}</span>" +
							"    {{view_more_container}}" +
							"</div>",

						cell_row_secondary_level: "" +
							"<div class='lvl secondary clear'>" +
							"    <div class='c10'>" +
						"           <div class='row product-row-container'>" +
							"             <ul class='c4 ticom-ui-icons-list'>" +
							"                 <li class='ticom-icon-item'>" +
							"                     <div class=\"ti_icon mod-size-s mod-color3\">\n" +
							"                         <svg role=\"img\">\n" +
							"                             <use xlink:href=\"/etc/designs/ti/images/icons/svg/ti_icons-objects.svg#shoppingCart\"></use>\n" +
							"                         </svg>\n" +
							"                     </div>\n" +
							"                   <a href='{{order}}' class='ticom-icon-label order-now' target='_blank'" +
							" name='{{products_linkid_ordernow}}'>{{cta_text1}}</a>" +
							"                 </li>" +
							"                 <li class='ticom-icon-item'>" +
							"                   <div class=\"ti_icon mod-size-s mod-color2\">" +
							"                       <svg role=\"img\">" +
							"                           <use xlink:href=\"/etc/designs/ti/images/icons/svg/ti_icons-objects.svg#onlineDataSheet\"></use>" +
							"                       </svg>" +
							"                   </div>" +
							"                   <a href='{{online_datasheet}}' class='ticom-icon-label' target='_blank' name='{{products_linkid_onlinedatasheet}}'>{{cta_text2}}</a>" +
							"                 </li>" +
							"                 <li class='ticom-icon-item'>" +
							"                   <div class=\"ti_icon mod-size-s mod-color2\">" +
							"                       <svg role=\"img\">" +
							"                           <use xlink:href=\"/etc/designs/ti/images/icons/svg/ti_icons-objects.svg#document-pdfAcrobat\"></use>" +
							"                       </svg>" +
							"                   </div>" +
							"                   <a href='{{download_datasheet}}' class='ticom-icon-label' target='_blank' name='{{products_linkid_downloaddatasheet}}'>{{cta_text3}}</a>" +
							"                 </li>" +
							"             </ul>" +
							"             <div class='c8'>{{row_description}}</div>" +
							"         </div>" +
							"    </div>" +
							"</div>"
					},

					headline_desc: "" +
						"<div class='subsystem-description'>" +
						"    <p>{{subsystem_desc}}</p>" +
						"</div>",

					image_box: {
						src: "<img src='{{row_image}}' />",
						fallback: "<span>&nbsp;</span>"
					}
				},

				// Version B related HTML assets
				B: {
					box_body: "" +
						"<div class='assoc-list-container'>" +
						"    <div class='assoc-list-headline'>" +
						"        <div class='headline-header'>" +
						"            <ul class='assoc-list-tabs'>" +
						"                <li data-prod-details-tab='ti-products'>" +
						"                    <span class='tab-title-box'>{{ti_prod_title}}</span>" +
						"                    <span class='ti-product-count'>(<span>0</span>)</span>" +
						"                </li>" +
						"                <li data-prod-details-tab='ref-designs'>" +
						"                    <span class='tab-title-box'>{{ref_design_title}}</span>" +
						"                    <span class='ref-design-count'>(<span>0</span>)</span>" +
						"                </li>" +
						"            </ul>" +
						"            <div id='sticky'></div>" +
						"        </div>" +
						"        <div class='ref-designs-products-container'>" +
						"           <div class='ti-products active'>" +
						"               <div id='group-header-index'></div>" +
						"           </div>" +
						"           <div class='ref-designs active'></div>" +
						"        </div>" +
						"    </div>" +
						"</div>",

					ref_design_row: "<div class='cell-row clear'>{{cell_row_primary_level}}{{cell_row_secondary_level}}</div>",

					product_row: "<div class='cell-row clear expandproduct'>{{cell_row_primary_level}}{{cell_row_secondary_level}}</div>",

					ref_design_cell_row: {
						cell_row_primary_level: "" +
							"<div class='lvl primary clear'>" +
							"    <span class='top-desc'>" +
							"        <a href='{{row_url}}' target='_blank' name='{{ref_designs_linkid_text}}'>{{row_name}}{{new_label}}</a>" +
							"    </span>" +
							"    {{view_more_container}}" +
							"</div>",

						cell_row_secondary_level: "" +
							"<div class='lvl secondary clear'>" +
							"    <div class='c11'>" +
							"        <div class='row'>" +
							"            <ul class='c3 ticom-ui-icons-list'>" +
							"                <li class='ticom-icon-item'>" +
							"                   <div class=\"ti_icon mod-size-s mod-color2\">" +
							"                       <svg role=\"img\">" +
							"                           <use xlink:href=\"/etc/designs/ti/images/icons/svg/ti_icons-objects.svg#document-web\"></use>" +
							"                       </svg>" +
							"                   </div>" +
							"                   <a href='{{diagram}}' class='ticom-icon-label' target='_blank' name='{{ref_designs_linkid_schematic}}'>{{cta_text1}}</a>" +
							"                </li>" +
							"                <li class='ticom-icon-item'>" +
							"                   <div class=\"ti_icon mod-size-s mod-color2\">" +
							"                       <svg role=\"img\">" +
							"                           <use xlink:href=\"/etc/designs/ti/images/icons/svg/ti_icons-objects.svg#document-generic\"></use>" +
							"                       </svg>" +
							"                   </div>" +
							"                   <a href='{{reference_guide}}' class='ticom-icon-label' target='_blank' name='{{ref_designs_linkid_referenceguide}}'>{{cta_text2}}</a>" +
							"                </li>" +
							"                <li class='ticom-icon-item'>" +
							"                   <div class=\"ti_icon mod-size-s mod-color2\">" +
							"                       <svg role=\"img\">" +
							"                           <use xlink:href=\"/etc/designs/ti/images/icons/svg/ti_icons-objects.svg#onlineDataSheet\"></use>" +
							"                       </svg>" +
							"                   </div>" +
							"                   <a href='{{row_url3}}' class='ticom-icon-label' target='_blank' name='{{ref_designs_linkid_viewfolder}}'>{{cta_text3}}</a>" +
							"                </li>" +
							"            </ul>" +
							"            <div class='c9'>{{row_desc1}}</div>" +
							"        </div>" +
							"    </div>" +
							"</div>"
					},

					product_cell_row: {
						cell_row_primary_level: "" +
							"<div class='lvl primary clear expandproduct'>" +
							"    <a href='{{row_url}}' class='link-primary' target='_blank' name='{{products_linkid_text}}'>{{row_gpn}}</a>" +
							"    &nbsp;&ndash;&nbsp;" +
							"    <span class='top-desc expandproduct'>{{row_desc}}{{new_label}}</span>" +
							"    {{view_more_container}}" +
							"</div>",

						cell_row_secondary_level: "" +
							"<div class='lvl secondary clear'>" +
							"    <div class='c10'>" +
						"        <div class='row product-row-container'>" +
						"            <ul class='c4 ticom-ui-icons-list'>" +
							"                <li class='ticom-icon-item'>" +
							"                   <div class=\"ti_icon mod-size-s mod-color3\">\n" +
							"                         <svg role=\"img\">\n" +
							"                             <use xlink:href=\"/etc/designs/ti/images/icons/svg/ti_icons-objects.svg#shoppingCart\"></use>\n" +
							"                         </svg>\n" +
							"                     </div>\n" +
							"                   <a href='{{order}}' class='ticom-icon-label order-now' target='_blank'" +
							" name='{{products_linkid_ordernow}}'>{{cta_text1}}</a></li>" +
							"                <li class='ticom-icon-item'>" +
							"                   <div class=\"ti_icon mod-size-s mod-color2\">" +
							"                       <svg role=\"img\">" +
							"                           <use xlink:href=\"/etc/designs/ti/images/icons/svg/ti_icons-objects.svg#onlineDataSheet\"></use>" +
							"                       </svg>" +
							"                   </div>" +
							"                   <a href='{{online_datasheet}}' class='ticom-icon-label' target='_blank' name='{{products_linkid_onlinedatasheet}}'>{{cta_text2}}</a>" +
							"                </li>" +
							"                <li class='ticom-icon-item'>" +
							"                   <div class=\"ti_icon mod-size-s mod-color2\">" +
							"                       <svg role=\"img\">" +
							"                           <use xlink:href=\"/etc/designs/ti/images/icons/svg/ti_icons-objects.svg#document-pdfAcrobat\"></use>" +
							"                       </svg>" +
							"                   </div>" +
							"                   <a href='{{download_datasheet}}' class='ticom-icon-label' target='_blank' name='{{products_linkid_downloaddatasheet}}'>{{cta_text3}}</a>" +
							"                </li>" +
							"            </ul>" +
						"            <div class='c8'>{{row_description}}</div>" +
							"        </div>" +
							"    </div>" +
							"</div>"
					},

					image_box: {
						src: "<img src='{{row_image}}'/>",
						fallback: "<span>&nbsp;</span>"
					}
				},

				// Generally shared HTML assets for all versions
				headline: "<h3></h3>",

				family_group_container: "" +
					"<div id='{{family_group_id}}' name='{{linkid_product_family}}' data-group-container class='family-group-header clear'>" +
					"    <span class='group-title'>{{family_group_name}}</span><span class='group-count'>(<span data-count-box>{{count}}</span>)</span>" +
					"    <span class='more-container-product show'>" +
					"        <a href='' name='{{linkid_more_product_family}}'>" +
					"            <i class='material-icons'></i>" +
					"        </a>" +
					"    </span>" +
					"    <div data-product-subfamily-list class='product-family-list-box clear'></div>" + //This is
				// the new line where the sub family get injected into
					"</div>",

				subfamily_group_container: "" +
				"<div id='{{subfamily_group_id}}' name='{{linkid_product_family}}' data-group-container" +
				" class='family-group-header subfamily clear {{show_subfamily}} subshow'>" +
					"   <div class='sub-header clear'>" +
					"       <div class='header-desc'>" +
					"           <span class='group-title subshow'>{{sub_family_group_name}} (<span data-count-box>{{count}}</span>)</span>" +
					"       </div>" +
					"       <div class='header-buttons'>" +
					"           <a href='#' data-compare-url='{{compare_Url}}' name='{{linkid_compare}}'" +
					" data-subfamily-cta='compare' class='button {{show_compare}}'>{{compare_text}}</a>" +
					"		</div>" +
					"       <span class='more-container-product'>" +
					"           <a href='' name='{{linkid_more_product_family}}'>" +
					"               <i class='material-icons subshow'></i>" +
					"           </a>" +
					"       </span>" +
					"   </div>" +
					"   <div data-product-family-list class='product-family-list-box clear {{expandcount}}'></div>" + //This is the new line where the list items get injected into
					"</div>",

				subfamily_cell: "<div class='subfamily-cell-row clear'>{{subfamilydiv}}</div>",

				family_group_header_wrapper: "<div class='group-header-wrapper' />",

				view_more_container: "" +
					"<span class='more-container'>" +
					"    <a href='' name='{{linkid_more}}' title='{{view_more}}'>" +
					"        <i class='material-icons'></i>" +
					"        <span></span>" +
					"    </a>" +
					"</span>",

				svg_view_more_container: "" +
					"<div class=\"more-container ti_icon mod-size-l mod-color1\">\n" +
					"    <svg role=\"img\">\n" +
					"        <use xlink:href=\"http://www.ti.com/etc/designs/ti/images/icons/svg/ti_icons-actions.svg#chevron-down\"></use>\n" +
					"    </svg>\n" +
					"</div>",

				view_less_container: "" +
					"<span class='more-container'>" +
					"    <a href='' name='{{linkid_less}}' title='{{view_less}}'><i class='material-icons collaps'></i><span></span></a>" +
					"</span>",

				svg_less_container: "" +
					"<div class=\"more-container ti_icon mod-size-l mod-color1\">\n" +
					"    <svg role=\"img\">\n" +
					"        <use xlink:href=\"http://www.ti.com/etc/designs/ti/images/icons/svg/ti_icons-actions.svg#chevron-up\"></use>\n" +
					"    </svg>\n" +
					"</div>",

				search_field: "" +
					"<div class=''>" +
					"    <form>" +
					"        <input type='text' name=''/>" +
					"        <input type='submit' value='Go'/>" +
					"    </form>" +
					"</div>",

				loader: "" +
					"<div class='spinner-target'>" +
					"    <div class='spinner-container'>" +
					"        <div class='spinner'></div>" +
					"    </div>" +
					"</div>",

				fallback_box: "<div class='fallback-container'>{{fallback_text}}</div>",

				alert_box: {
					html: "" +
						"<div class='row error-check summary success'>" +
						"    <h4>{{alert_title}}</h4>" +
						"    <p>{{alert_message}}</p>" +
						"    <a href='{{alert_url2}}' class='more' target='_blank'>{{alert_cta}}</a>" +
						"</div>",

					url: {
						analog_input_module: "https://s2.userzoom.com/m/MSBDMTU3Uzk1?EEQ=AIM",
						hvac_gateway: "https://s2.userzoom.com/m/MSBDMTU3Uzk1?EEQ=HVAC",
						front_camera: "https://s2.userzoom.com/m/MSBDMTU3Uzk1?EEQ=FCAM",
						head_unit_with_integrated_display: "https://s2.userzoom.com/m/MSBDMTU3Uzk1?EEQ=HUNIT"
					}
				},
				view: {
					collapse: "<a href=''><i class='material-icons collapse'></i></a>",

					expand: "<a href=''><i class='material-icons'></i></a>"
				},

				version: {
					defaults: "c3 c4 c9 c8 c12",
					A1: ["c9", "c3"],
					A2: ["c4", "c8"],
					B: ["", ""]
				},

				section_header1: "<h2 id='Reference Designs' class='eerd-section-header'>{{section_header_title}}</h2><p>{{section_description}}</p>",
                section_header2: "{{section_header_title}}",
				section_desc_box: "<p data-section-description>{{section_description}}</p>",
				new_label: "<span class='new-label'> - <span class='ti_p-newBadge'> {{labelnew}} </span></span>",
			    ref_new_label: "<span class='new-label'> <span class='ti_p-newBadge'>{{labelnew}} </span> - </span>",
				anchor_link: "<a href='{{anchorlink}}' data-lid='top_anchor_ref_designs'>{{anchorlink_label}}</a>"
			},

			row_icons: {
				online_datasheet: "doc",
				order_now: "cart",
				download_datasheet: "dlDatasheet",
				schematic_diagram: "html",
				reference_guide: "doc",
				reference_design: "refdesign"
			},

			// LinkID related assets
			link_id: {
				region: {
					en: "en_US",
					cn: "zh_CN",
					jp: "ja_jp"
				},

				// A1 linkID assets
				A1: {
					subsys: "&lid={{linkid_region}}_eerd_a1_{{eename}}_{{subsysname}}_block",
					ref_designs: {
						tab: "&lid={{linkid_region}}_eerd_a1_{{eename}}_{{subsysname}}_refdesigns_tab",
						image: "&lid={{linkid_region}}_eerd_a1_{{eename}}_{{subsysname}}_refdesigns_{{tpn}}_image",
						text: "&lid={{linkid_region}}_eerd_a1_{{eename}}_{{subsysname}}_refdesigns_{{tpn}}_text",
						more: "&lid={{linkid_region}}_eerd_a1_{{eename}}_{{subsysname}}_refdesigns_{{tpn}}_more",
						less: "&lid={{linkid_region}}_eerd_a1_{{eename}}_{{subsysname}}_refdesigns_{{tpn}}_less",
						schematic: "&lid={{linkid_region}}_eerd_a1_{{eename}}_{{subsysname}}_refdesigns_{{tpn}}_schematic",
						reference_guide: "&lid={{linkid_region}}_eerd_a1_{{eename}}_{{subsysname}}_refdesigns_{{tpn}}_referenceguide",
						view_folder: "&lid={{linkid_region}}_eerd_a1_{{eename}}_{{subsysname}}_refdesigns_{{tpn}}_viewfolder"
					},
					products: {
						tab: "&lid={{linkid_region}}_eerd_a1_{{eename}}_{{subsysname}}_products_tab_source={{source}}",
						image: "&lid={{linkid_region}}_eerd_a1_{{eename}}_{{subsysname}}_products_{{gpn}}_image_source={{source}}",
						text: "&lid={{linkid_region}}_eerd_a1_{{eename}}_{{subsysname}}_products_{{gpn}}_text_source={{source}}",
						more: "&lid={{linkid_region}}_eerd_a1_{{eename}}_{{subsysname}}_products_{{gpn}}_more_source={{source}}",
						less: "&lid={{linkid_region}}_eerd_a1_{{eename}}_{{subsysname}}_products_{{gpn}}_less_source={{source}}",
						download_datasheet: "&lid={{linkid_region}}_eerd_a1_{{eename}}_{{subsysname}}_products_{{gpn}}_downloaddatasheet_source={{source}}",
						online_datasheet: "&lid={{linkid_region}}_eerd_a1_{{eename}}_{{subsysname}}_products_{{gpn}}_onlinedatasheet_source={{source}}",
						order_now: "&lid={{linkid_region}}_eerd_a1_{{eename}}_{{subsysname}}_products_{{gpn}}_ordernow_source={{source}}"
					},
					product_family_header: "&lid={{linkid_region}}_eerd_diagram_{{eename}}_{{subsysname}}_productfamily-{{productFamily}}_source={{source}}",
					product_subfamily_header: "&lid={{linkid_region}}_eerd_diagram_{{eename}}_{{subsysname}}_subfamily-{{productFamily}}_source={{source}}",
					compare_header : "&lid={{linkid_region}}_eerd_a1_{{eename}}_{{subsysname}}_products_{{subFamilyId}}_compare_source={{source}}",
					description_link: "&lid={{linkid_region}}_eerd_a1_{{eename}}_{{subsysname}}_description-link",
					search_all_header : "&lid={{linkid_region}}_eerd_a1_{{eename}}_{{subsysname}}_products_{{subFamilyId}}_searchall_source={{source}}"
				},

				// A2 linkID assets
				A2: {
					subsys: "&lid={{linkid_region}}_eerd_a2_{{eename}}_{{subsysname}}_list",
					ref_designs: {
						tab: "&lid={{linkid_region}}_eerd_a2_{{eename}}_{{subsysname}}_refdesigns_tab",
						image: "&lid={{linkid_region}}_eerd_a2_{{eename}}_{{subsysname}}_refdesigns_{{tpn}}_image",
						text: "&lid={{linkid_region}}_eerd_a2_{{eename}}_{{subsysname}}_refdesigns_{{tpn}}_text",
						more: "&lid={{linkid_region}}_eerd_a2_{{eename}}_{{subsysname}}_refdesigns_{{tpn}}_more",
						less: "&lid={{linkid_region}}_eerd_a2_{{eename}}_{{subsysname}}_refdesigns_{{tpn}}_less",
						schematic: "&lid={{linkid_region}}_eerd_a2_{{eename}}_{{subsysname}}_refdesigns_{{tpn}}_schematic",
						reference_guide: "&lid={{linkid_region}}_eerd_a2_{{eename}}_{{subsysname}}_refdesigns_{{tpn}}_referenceguide",
						view_folder: "&lid={{linkid_region}}_eerd_a2_{{eename}}_{{subsysname}}_refdesigns_{{tpn}}_viewfolder"
					},
					products: {
						tab: "&lid={{linkid_region}}_eerd_a2_{{eename}}_{{subsysname}}_products_tab_source={{source}}",
						image: "&lid={{linkid_region}}_eerd_a2_{{eename}}_{{subsysname}}_products_{{gpn}}_image_source={{source}}",
						text: "&lid={{linkid_region}}_eerd_a2_{{eename}}_{{subsysname}}_products_{{gpn}}_text_source={{source}}",
						more: "&lid={{linkid_region}}_eerd_a2_{{eename}}_{{subsysname}}_products_{{gpn}}_more_source={{source}}",
						less: "&lid={{linkid_region}}_eerd_a2_{{eename}}_{{subsysname}}_products_{{gpn}}_less_source={{source}}",
						download_datasheet: "&lid={{linkid_region}}_eerd_a2_{{eename}}_{{subsysname}}_products_{{gpn}}_downloaddatasheet_source={{source}}",
						online_datasheet: "&lid={{linkid_region}}_eerd_a2_{{eename}}_{{subsysname}}_products_{{gpn}}_onlinedatasheet_source={{source}}",
						order_now: "&lid={{linkid_region}}_eerd_a2_{{eename}}_{{subsysname}}_products_{{gpn}}_ordernow_source={{source}}"
					},
					product_family_header: "&lid={{linkid_region}}_eerd_{{eename}}_{{subsysname}}_productfamily-{{productFamily}}_source={{source}}",
					product_subfamily_header: "&lid={{linkid_region}}_eerd_diagram_{{eename}}_{{subsysname}}_subfamily-{{productFamily}}_source={{source}}",
					compare_header : "&lid={{linkid_region}}_eerd_a2_{{eename}}_{{subsysname}}_products_{{subFamilyId}}_compare_source={{source}}",
					description_link: "&lid={{linkid_region}}_eerd_a2_{{eename}}_{{subsysname}}_description-link",
					search_all_header : "&lid={{linkid_region}}_eerd_a2_{{eename}}_{{subsysname}}_products_{{subFamilyId}}_searchall_source={{source}}"
				},

				// B linkID assets
				B: {
					ref_designs: {
						tab: "&lid={{linkid_region}}_eerd_b_{{eename}}_refdesigns_tab",
						image: "&lid={{linkid_region}}_eerd_b_{{eename}}_refdesigns_{{tpn}}_image",
						text: "&lid={{linkid_region}}_eerd_b_{{eename}}_refdesigns_{{tpn}}_text",
						more: "&lid={{linkid_region}}_eerd_b_{{eename}}_refdesigns_{{tpn}}_more",
						less: "&lid={{linkid_region}}_eerd_b_{{eename}}_refdesigns_{{tpn}}_less",
						schematic: "&lid={{linkid_region}}_eerd_b_{{eename}}_refdesigns_{{tpn}}_schematic",
						reference_guide: "&lid={{linkid_region}}_eerd_b_{{eename}}_refdesigns_{{tpn}}_referenceguide",
						view_folder: "&lid={{linkid_region}}_eerd_b_{{eename}}_refdesigns_{{tpn}}_viewfolder"
					},
					products: {
						tab: "&lid={{linkid_region}}_eerd_b_{{eename}}_products_tab_source={{source}}",
						image: "&lid={{linkid_region}}_eerd_b_{{eename}}_products_{{gpn}}_image_source={{source}}",
						text: "&lid={{linkid_region}}_eerd_b_{{eename}}_products_{{gpn}}_text_source={{source}}",
						more: "&lid={{linkid_region}}_eerd_b_{{eename}}_products_{{gpn}}_more_source={{source}}",
						less: "&lid={{linkid_region}}_eerd_b_{{eename}}_products_{{gpn}}_less_source={{source}}",
						download_datasheet: "&lid={{linkid_region}}_eerd_b_{{eename}}_products_{{gpn}}_downloaddatasheet_source={{source}}",
						online_datasheet: "&lid={{linkid_region}}_eerd_b_{{eename}}_products_{{gpn}}_onlinedatasheet_source={{source}}",
						order_now: "&lid={{linkid_region}}_eerd_b_{{eename}}_products_{{gpn}}_ordernow_source={{source}}"
					},
					product_family_header: "&lid={{linkid_region}}_eerd_{{eename}}_{{subsysname}}_productfamily-{{productFamily}}_source={{source}}",
					product_subfamily_header: "&lid={{linkid_region}}_eerd_diagram_{{eename}}_{{subsysname}}_subfamily-{{productFamily}}_source={{source}}",
					compare_header : "&lid={{linkid_region}}_eerd_b_{{eename}}_{{subsysname}}_products_{{subFamilyId}}_compare_source={{source}}",
					search_all_header : "&lid={{linkid_region}}_eerd_b_{{eename}}_{{subsysname}}_products_{{subFamilyId}}_searchall_source={{source}}"
				}
			},
			option: {
				url: "http://www.ti.com",
				fallback_image: "/assets/images/clear.gif"
			},

			// Text related assets
			text: {
				anchor_link: "referencedesigns",
				ref_designs: "Reference Designs",
				en: { //English language
					error_message: "There was an error retrieving data for this subsystem.  Please select another.",
					section_header_title: "Reference designs & products",
					section_description: "Quickly find featured reference designs and products for your system design.",
					fallback: {
						subsystemName: "Subsystem"
					},
					diagram_container: {
						title: "Select a subsystem",
						variantTitle: "Select a subsystem for:"
					},
					ref_designs: {
						tab: {
							desktop: "Reference designs"
						},
						cta: ["Schematic/Block diagram", "Reference guide", "View reference design"],
						fallback: "There are currently no reference designs to display"
					},
					ti_prod: {
						tab: "Products",
						cta: ["Order now", "Online datasheet", "Download datasheet"],
						fallback: "There are currently no products to display"
					},
					view: {
						more: "More",
						less: "Less"
					},
					view_more: "View more",
					view_less: "View less",
					read: {
						more: "Read more",
						less: "Read less"
					},
					alert_box: {
						title: "Your feedback is important!",
						message: "We have improved how you find reference designs and TI products for end equipment. Please complete a brief survey and tell us what you think.",
						cta: "Take the survey"
					},
					compare_text: "Compare",
					searchall_text: "Search",
					labelnew: "NEW",
					read_description: "Description"
				},
				cn: { //Chinese language (simplified)
					error_message: "There was an error retrieving data for this subsystem.  Please select another.",
					section_header_title: "参考设计及 产品",
					section_description: "快速找到适合您的系统设计的特色参考设计和产品。",
					fallback: {
						subsystemName: "子系统"
					},
					diagram_container: {
						title: "选择子系统",
						variantTitle: "精选子系统"
					},
					ref_designs: {
						tab: {
							desktop: "参考设计"
						},
						cta: ["原理图 / 方框图", "参考指南", "查看参考设计"],
						fallback: "未找到参考设计搜索结果"
					},
					ti_prod: {
						tab: "产品",
						cta: ["立即订购", "在线数据表", "下载产品说明书"],
						fallback: "未找到产品搜索结果"
					},
					view: {
						more: "更多",
						less: "更少"
					},
					view_more: "查看更多内容",
					view_less: "隐藏此内容",
					read: {
						more: "Read more",
						less: "Read less"
					},
					alert_box: {
						title: "您的反馈非常重要！",
						message: "我们改进了查找适用于终端设备的参考设计和 TI 产品的方法。 请完成这项简短调查，并告诉我们您的想法。",
						cta: "参加调查"
					},
					compare_text: "比较",
					searchall_text: "Search",
					labelnew: "新产品",
					read_description: "Description"
				},
				jp: { //Japanese language
					error_message: "There was an error retrieving data for this subsystem.  Please select another.",
					section_header_title: "リファレンス・デザインと製品",
					section_description: "システム設計に適した主なリファレンス・デザインと製品をすぐに検索できます。",
					fallback: {
						subsystemName: "サブ・システム"
					},
					diagram_container: {
						title: "サブシステムの選択",
						variantTitle: "サブシステムを選択"
					},
					ref_designs: {
						tab: {
							desktop: "リファレンス・デザイン"
						},
						cta: ["回路図 / ブロック図", "リファレンス・ガイド", "リファレンス・デザイン"],
						fallback: "リファレンス・デザインの検索結果"
					},
					ti_prod: {
						tab: "製品",
						cta: ["ご注文はこちら", "オンライン・データシート", "データシートのダウンロード"],
						fallback: "製品の結果はありません"
					},
					view: {
						more: "その他",
						less: "未満"
					},
					view_more: "詳細を表示",
					view_less: "詳細を非表示",
					read: {
						more: "Read more",
						less: "Read less"
					},
					alert_box: {
						title: "ご意見をお聞かせください。",
						message: "最終製品に適したリファレンス・デザインと製品の検索方法を改善しました。 短いアンケート調査により、ご意見をお聞かせいただけると幸いです。",
						cta: "アンケートに回答"
					},
					compare_text: "比較",
					searchall_text: "Search",
					labelnew: "新製品",
					read_description: "Description"
				}
			}
		}
	};

	return private_variables[str];
};
